import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseHttpService } from './base-http.service';
import { environment } from '../../environments/environment';

export interface Driver {
  id: number;
  name: string;
  surname: string;
  phoneNumber?: string | null;
  driverCardNumber?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class DriverService extends BaseHttpService {
  private apiUrl = environment.trackycontrol;

  getDrivers(clientId: number): Observable<Driver[]> {
    return this.post<Driver[]>(`${this.apiUrl}/api/drivers/byFilters?clientId.equals=${clientId}&page=0&size=10000`, {});
  }
}